module.exports = __webpack_public_path__ + "static/img/logof.95ea699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/logof.png
// module id = 3hrZ
// module chunks = 1